var map = {
	"./Elements.svg": "BXyk",
	"./Logos.svg": "MgmS",
	"./Pattern.svg": "Cmzx",
	"./bg-pattern.svg": "3MkF",
	"./bg-pattern2.svg": "3ZxX",
	"./bg-pattern3.svg": "YWD0",
	"./bookkeeping-logo.svg": "JUId",
	"./careers/divider1.svg": "qgZy",
	"./careers/share.svg": "mt8o",
	"./clients/hubspot.svg": "ovTr",
	"./desktop.svg": "AFaS",
	"./divider.svg": "qS89",
	"./element.svg": "haLm",
	"./footer-shape-1.svg": "UTDP",
	"./footer-shape-2.svg": "6lUa",
	"./group.svg": "ijuW",
	"./icon-laptop.svg": "+uc4",
	"./icons/back-arrow.svg": "VXNS",
	"./icons/building.svg": "V1Eh",
	"./icons/gradient-right-arrow.svg": "HtvS",
	"./icons/phone-primary.svg": "Wl7Y",
	"./icons/phone.svg": "mFXo",
	"./icons/right-arrow-primary-02-blue.svg": "bx94",
	"./icons/right-arrow-primary-02.svg": "2phV",
	"./icons/right-arrow-primary.svg": "8aYn",
	"./icons/right-arrow-secondary.svg": "nLgZ",
	"./icons/slider-next-arrow.svg": "K/1M",
	"./icons/slider-prev-arrow.svg": "TAT/",
	"./icons/white-arrow-left.svg": "42FW",
	"./icons/white-arrow-right.svg": "ylHo",
	"./illustration-2.svg": "e3gt",
	"./illustration-3.svg": "RlK5",
	"./illustration-4.svg": "67Cs",
	"./illustration-main.svg": "jpCb",
	"./illustration.svg": "jVXa",
	"./logo-circle.svg": "1qnk",
	"./logo-dark.svg": "pZm2",
	"./logo-grad.svg": "pzwF",
	"./logo-white.svg": "4da7",
	"./pattern-3.svg": "DFE/",
	"./quote.svg": "3gu3",
	"./robotic-logo.svg": "t+wR",
	"./social-icons.svg": "UnXJ",
	"./social/facebook-primary.svg": "2fZz",
	"./social/facebook.svg": "CYU0",
	"./social/linkedin-primary.svg": "qTAX",
	"./social/linkedin.svg": "28kG",
	"./social/social-channels.svg": "WfNX",
	"./social/twitter-primary.svg": "/SEd",
	"./social/twitter.svg": "POI7",
	"./social/youtube-primary.svg": "rg1s",
	"./social/youtube.svg": "aG1u",
	"./thunder.svg": "n3bn",
	"./webservices-logo.svg": "za9v"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BZFM";